import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { CrossMark, LOGO } from "@/components/PublicLayout";
import { Field, BigButton, inputCls } from "@/components/FormBits";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/office" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(email, password); nav("/office"); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]">
      <div className="hidden lg:flex flex-col justify-between bg-[#4A2E1A] text-[#FDFBF7] p-12 relative overflow-hidden">
        <CrossMark className="absolute -right-16 -bottom-16 w-[420px] h-[420px] text-[#C59B27]/10" />
        <img src={LOGO} alt="Saint Francis of Assisi Parish logo" className="w-28 h-28 object-contain bg-white rounded-full p-1" />
        <p className="font-serif-head font-black tracking-wide text-xl">MABUHAY CARE</p>
        <div>
          <p className="font-serif-head text-3xl leading-snug max-w-md">"A submitted request is not merely a record. It represents a person deserving attention, dignity, and care."</p>
          <p className="mt-6 text-[#E9DCCF]">Pastoral Office · Saint Francis of Assisi Parish</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="staff-login-form">
          <span className="w-12 h-12 rounded-full bg-[#F4EBE4] text-[#4A2E1A] flex items-center justify-center"><Lock className="w-5 h-5" /></span>
          <h1 className="text-3xl font-black">Pastoral office login</h1>
          <p className="text-[15px] text-[#605349]">For authorized parish personnel only. Accounts are created by parish leadership; there is no public sign-up.</p>
          <Field label="Email" htmlFor="le"><input id="le" data-testid="login-email-input" type="email" autoComplete="username" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <Field label="Password" htmlFor="lp"><input id="lp" data-testid="login-password-input" type="password" autoComplete="current-password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} /></Field>
          <BigButton type="submit" data-testid="login-submit-button" disabled={busy || !email || !password} className="w-full">{busy ? "Signing in…" : "Sign in"}</BigButton>
          <p className="text-xs text-[#605349]">Sessions sign out automatically after 15 minutes of inactivity. Do not sign in on shared or public devices.</p>
          <a href="/" data-testid="login-back-home" className="block text-sm underline text-[#4A2E1A]">Back to public site</a>
        </form>
      </div>
    </div>
  );
}
